import React,{useContext} from 'react';
import Button from './common/Button';
import appLogo from '../assets/Apps.svg';

const ConsentCard = ({
	consent,
	isSelected,
	onSelect,
	onViewDetails,
	customDetails,
}) => {

	const dateFormat = (dateString) => {
		if (dateString) {
			let newDate = new Date(dateString);
			let dataArray = newDate.toString().split(' ');
			return `${dataArray[2]} ${dataArray[1]} ${dataArray[3]} ${dataArray[4]}`;
		}
	};

	const handleViewDetails = () =>{
		onViewDetails(
			consent?.consentIntentId,
			consent?.consentIntentEntityName,
			consent
		)
	}

	const getStatusColor = (status) => {
		switch (status) {
			case 'ACTIVE':
				return '#D9F8F4';
			case 'PAUSED':
				return '#FFF8EC';
			default:
				return '#D9DDF';
		}
	};

	return (
		<div className="col-12 mb-3">
			<div className="border border-1 border-black rounded-3 p-2 py-md-2 px-md-4 py-lg-2 px-lg-4">
				<div className="row p-2">
					<div className="col-6">
						<img
							src={!consent?.entityLogoUri ? appLogo : consent?.entityLogoUri}
							className="float-start mt-2"
							style={{ width: 'auto', height: 'auto', objectFit: 'contain' }}
							alt="Logo_URL"
						/>
					</div>
					<div className="col-6" style={{ alignSelf: 'center' }}>
						<div className="form-check form-check-inline float-end">
							<span
								className={`form-check-input ${
									isSelected ? 'selected-circle border-0' : 'border-circle'
								}`}
								onClick={() => onSelect(consent)}
							/>
						</div>
					</div>
				</div>
				<div className="row p-2">
					<div className="col-12">
						<p
							className="fw-700 text-start"
							style={{ color: customDetails.primaryColor }}
						>
							{consent?.consentIntentEntityName}
						</p>
					</div>
					<div className="col-6">
						<p
							className="fs-12 fw-600 text-start mb-2"
							style={{ color: '#828282' }}
						>
							Purpose
						</p>
					</div>
					<div className="col-6">
						<p
							className="fs-12 fw-600 text-end mb-2"
							style={{ color: '#828282' }}
						>
							Consent given on
						</p>
					</div>
					<div className="col-7">
						<p className="fs-12 fw-600 text-black text-start">
							{consent?.consentPurposeText}
						</p>
					</div>
					<div className="col-5">
						<p className="fs-12 fw-600 text-black text-end">
							{dateFormat(consent?.consentIntentUpdateTimestamp)}
						</p>
					</div>
					<div className="row p-2 mt-auto">
						<div className="col-7 text-start">
							<span
								className="fs-12 fw-600 px-2 py-1 rounded-pill d-inline-block"
								style={{ backgroundColor: getStatusColor(consent?.status) }}
							>
								{consent?.status}
							</span>
						</div>
						<div className="col-5 d-flex justify-content-end p-0">
							<Button
								className="fs-16 fw-700 bg-transparent border-0 rounded-3"
								style={{ color: customDetails.primaryColor }}
								onClick={handleViewDetails}
							>
								DETAILS
							</Button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ConsentCard;
